import { useContext } from "react";
import { useQuery } from "react-query";
import { AxiosContext } from "services/axios.context";
import { AuthenticationContext } from "services/authentication.context";

export const useAuction = (id, initialData = {}) => {
  const { isAuthenticated } = useContext(AuthenticationContext);
  const { client } = useContext(AxiosContext);
  const axios = isAuthenticated ? client : client;
  return useQuery(
    `auction-${id}`,
    () => {
      console.debug(`💰 Auction ${id}`);
      return axios.get(`auctions/${id}/`).then((resp) => resp.data);
    },
    {
      enabled: !!id,
      placeholderData: initialData,
      staleTime: 5000,
      refetchOnWindowFocus: true,
    }
  );
};
